import ResumeEducationSummary from "./ResumeEducationSummary";

export default ResumeEducationSummary;
